import React, { useState } from "react";
import PropTypes from "prop-types";
import { Radio, Icon, Tooltip } from "antd";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import {
  DETAIL_ACTIONS,
  CAMPAIGN as CAMPAIGN_ENUM
} from "../../../../../../constants/Define";
import {
  capitalizeFirstLetter,
  checkUndefine
} from "../../../../../../helpers/functions";
import { useTranslation } from "react-i18next";
import { toArray } from "lodash";
import Input from "../../../../common/component/Input";

const defaultCollapseKey = "specialEventSection";

function SpecialEventSection(props) {
  const { campaign, action, onChange, setCampaign } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  const changeCodeType = isLoyalty => {
    // isLoyalty type boolean
    if (!isLoyalty) {
      onChange("codeType", CAMPAIGN_ENUM.CODE_TYPE.STANDARD.value);
    } else {
      onChange("codeType", CAMPAIGN_ENUM.CODE_TYPE.CUSTOMIZE.value);
    }
  };

  const onChangeRadio = value => {
    if (!campaign) return
    campaign.freeNightStay = undefined;
    campaign.loyaltyCode = undefined;
    campaign.loyaltyBenefitCode = undefined;
    campaign.loyaltyCampaignCode = undefined;

    if (value === 1) {
      campaign.isLoyaltyBenefit = !campaign.isLoyaltyBenefit;
      campaign.isLoyaltyVoucher = false;
    }
    if (value === 2) {
      campaign.isLoyaltyVoucher = !campaign.isLoyaltyVoucher;
      campaign.isLoyaltyBenefit = false;
    }
    setCampaign(campaign, () => {
      changeCodeType(value === 2);
    });
  };

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.specialEvent.title")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Radio.Group
                value={
                  campaign.isLoyaltyVoucher
                    ? 2
                    : campaign.isLoyaltyBenefit
                    ? 1
                    : 0
                }
              >
                {toArray(CAMPAIGN_ENUM.SPECIAL_EVENT).map(item => (
                  <Radio
                    key={item.key}
                    value={item.value}
                    className="mr-0"
                    style={{
                      fontWeight: 500
                    }}
                    onClick={() => onChangeRadio(item.value)}
                  >
                    {t(`item.campaign.specialEvent.${item.label}`)}
                  </Radio>
                ))}
              </Radio.Group>
            </FormWrapperInputComponent>
          </Wrapper>
          {campaign.isLoyaltyBenefit && (
            <Wrapper className="col-md-6">
              <Wrapper className="row">
                <Wrapper className="col-md-6">
                  <FormWrapperInputComponent
                    labelTitle={t("item.campaign.specialEvent.numberUse")}
                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control text-right"
                      name="freeNightStay"
                      onChange={e =>
                        onChange("freeNightStay", Number(e.target.value))
                      }
                      value={checkUndefine(campaign.freeNightStay)}
                      placeholder={capitalizeFirstLetter(
                        t("placeHolderForm.input") +
                          " " +
                          t(`item.campaign.freeNightStay`).toLowerCase()
                      )}
                    />
                  </FormWrapperInputComponent>
                </Wrapper>

                <Wrapper className="col-md-6">
                  <FormWrapperInputComponent
                    labelTitle={
                      <span>
                        {t("item.campaign.loyaltyCode")}
                        &nbsp;
                        <Tooltip title={t("item.campaign.loyaltyCodeRequire")}>
                          <Icon type="info-circle" />
                        </Tooltip>
                      </span>
                    }
                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      name="loyaltyCode"
                      onChange={e => onChange("loyaltyCode", e.target.value)}
                      value={checkUndefine(campaign.loyaltyCode)}
                      placeholder={capitalizeFirstLetter(
                        t("placeHolderForm.input") +
                          " " +
                          t(`item.campaign.loyaltyCode`).toLowerCase()
                      )}
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
              </Wrapper>
            </Wrapper>
          )}
          {/* {campaign.isLoyaltyVoucher && <Wrapper className="col-md-6">
                                        <Wrapper className="row">
                                            <Wrapper className="col-md-6">
                                                <FormWrapperInputComponent
                                                    labelTitle={ t("item.campaign.specialEvent.codeBenefit") }
                                                    isRequired={ true }
                                                    isValidation={ true }
                                                    dataValidation={ campaign.loyaltyBenefitCode }
                                                    validation={ validation.loyaltyBenefitCode }
                                                >
                                                    <Input type="text"
                                                        autoComplete="off"
                                                        placeholder={ t("item.campaign.loyaltyBenefitCode") }
                                                        className="form-control" name="loyaltyBenefitCode" onChange={ (e) => onChange('loyaltyBenefitCode', e.target.value) }
                                                        value={ campaign.loyaltyBenefitCode ? campaign.loyaltyBenefitCode : "" }
                                                        disabled={ !campaign.canEdit } />
                                                </FormWrapperInputComponent>
                                            </Wrapper>
                                            <Wrapper className="col-md-6">
                                                <FormWrapperInputComponent
                                                    labelTitle={ t("item.campaign.specialEvent.codeCampaign") }
                                                    isRequired={ true }
                                                    isValidation={ true }
                                                    dataValidation={ campaign.loyaltyCampaignCode }
                                                    validation={ validation.loyaltyCampaignCode }
                                                >
                                                    <Input type="text"
                                                        autoComplete="off"
                                                        placeholder={ t("item.campaign.loyaltyCampaignCode") }
                                                        className="form-control" name="loyaltyCampaignCode" onChange={ (e) => onChange('loyaltyCampaignCode', e.target.value) }
                                                        value={ campaign.loyaltyCampaignCode ? campaign.loyaltyCampaignCode : "" }
                                                        disabled={ !campaign.canEdit } />
                                                </FormWrapperInputComponent>
                                            </Wrapper>
                                        </Wrapper>
                                    </Wrapper>
                                    } */}
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

SpecialEventSection.propTypes = {
  campaign: PropTypes.object,
  action: PropTypes.string,
  onChange: PropTypes.func,
  setCampaign: PropTypes.func
};

SpecialEventSection.defaultProps = {
  campaign: {},
  action: "",
  onChange: () => {},
  setCampaign: () => {}
};

export default SpecialEventSection;
